export default "__VITE_ASSET__it_Pxorb__"